export default "__VITE_ASSET__55JoxWFm__"